import { VStack, VStackTypes } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Text } from 'native-base';
import React from 'react';

import { SenderType } from '../../hooks/chat';
import { useMessage } from '../../hooks/message';

interface MessageProps {
  sender: SenderType;
  text: string;
}

export const Message: React.FC<MessageProps> = ({ sender, text }) => {
  const { formatText } = useMessage();

  const styles: Record<SenderType, Partial<VStackTypes.Props>> = {
    User: {
      alignSelf: 'flex-end',
      bg: Color['neutral.white'],
    },
    Bot: {
      alignSelf: 'flex-start',
      bg: Color['brand.tertiary.lightest'],
    },
  };

  return (
    <VStack
      maxW="80%"
      borderWidth="1px"
      py={Spacing['stack.nano']}
      px={Spacing['stack.xxs']}
      borderColor={Color['brand.primary.lightest']}
      borderRadius={BoxRadius.sm}
      {...styles[sender]}>
      <Text
        lineHeight={Typography['lineheight.distant']}
        fontSize={Typography['fontsize.md']}
        color={Color['neutral.darkest']}
        variant="regular">
        {formatText(text)}
      </Text>
    </VStack>
  );
};
